import { components } from './components/index';
import { ThemeConfig } from '@telescope/cassini-ui';
import { foundations } from './foundations';

const config: ThemeConfig = {
  useSystemColorMode: false,
  initialColorMode: 'light',
  cssVarPrefix: 'cassini',
};

// Base Theme is merged with theme from widget. Widget theme has higher precedence and overrides base theme values
export const baseTheme = {
  config,
  components,
  ...foundations,
};
